import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';

import { ReleaseCollectedByManyUsersDocument, useInfiniteQuery } from '@graphql/reactQuery';
import { UserListModalBody } from './CollectedUserModalBody';

/*#__PURE__*/ gql(/* GraphQL */ `
  query releaseCollectedByManyUsers(
    $activityFeedGroupId: UUID!
    $pagination: CursorConnectionArgs!
  ) {
    releaseCollectedByManyUsers(
      activityFeedGroupId: $activityFeedGroupId
      pagination: $pagination
    ) {
      edges {
        node {
          id
          ...UserModalInfo
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`);

export const ActivityCollectedByModal = ({ activityId }: { activityId: string }) => {
  const { closeCancelModal } = ModalContext.useContainer();

  const { orderedList: collectors, loadMoreNextPage: loadMore } = useInfiniteQuery(
    ReleaseCollectedByManyUsersDocument,
    {
      getNextPageParam({ data }) {
        return (
          data.releaseCollectedByManyUsers.pageInfo.hasNextPage && {
            after: data.releaseCollectedByManyUsers.pageInfo.endCursor,
          }
        );
      },
      filterQueryKey: {
        activityId,
      },
      variables({ pageParam }) {
        return {
          activityFeedGroupId: activityId,
          pagination: {
            first: 10,
            after: pageParam?.after || null,
          },
        };
      },
      list({ releaseCollectedByManyUsers }) {
        return releaseCollectedByManyUsers.edges.map(edge => edge.node);
      },
      uniq({ id }) {
        return id;
      },
      staleTime: 0,
    },
  );

  const body = (
    <UserListModalBody
      userList={collectors}
      loading={!collectors || collectors.length === 0}
      loadMore={loadMore}
    />
  );

  return (
    <Modal
      headerText="Collected by"
      body={body}
      closeModal={closeCancelModal}
      bodyStyles={{
        paddingLeft: 16,
        marginTop: 0,
        '@tablet': {
          marginTop: 0,
          paddingLeft: 24,
        },
      }}
      containerStyles={{
        padding: 0,
        marginTop: 0,
      }}
      headerStyles={{
        padding: '16px 16px 2px',
        '@tablet': {
          padding: '24px 24px 2px',
        },
      }}
    />
  );
};
